import { render } from "./ProviderItem.vue?vue&type=template&id=96c901d0"
import script from "./ProviderItem.vue?vue&type=script&lang=js"
export * from "./ProviderItem.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__